import './QdCheckbox.scss';
import template from './QdCheckbox.vhtml';

export default {
	name: 'QdCheckbox',
	template: template,
	props: {
		value: {
			type: Array,
			default: [],
		},
		checkValue: '',
		checkKey:  {
			type: String,
			default: '',
		},
		colorful: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({}),
	computed: {
		isSelected: vm => {
			return !!vm.value.find(value => value === vm.checkValue);
		},
		checkboxClasses: vm => {
			let dynamicClasses = {
				'qd-checkbox--selected': vm.isSelected,
				'qd-checkbox--colorful': vm.colorful,
			};

			return ['qd-checkbox', dynamicClasses];
		},
		iconClasses: vm => {
			let dynamicClasses = {
				'qd-checkbox__icon--white-border': vm.colorful,
				'qd-checkbox__icon--selected': vm.isSelected,
			};

			return ['qd-checkbox__icon', dynamicClasses];
		},
		labelClasses: vm => {
			let dynamicClasses = {
				'qd-checkbox__label--selected': vm.isSelected,
			};

			return ['qd-checkbox__label', dynamicClasses];
		},
	},
	methods: {
		updateData() {
			if (this.value.find(value => value === this.checkValue)) {
				this.$emit('input', this.value.filter(value => value !== this.checkValue));
			} else {
				this.$emit('input', [...this.value, this.checkValue]);
			}
		}
	},
};
